(function () {
  var ROOT_SELECTOR = "[data-darkstone-pull-list-portal]";
  var DEFAULT_SORT = "foc-soon";
  const MAX_VISIBLE_PULL_HISTORY = 50;

  function escapeHtml(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  // FOC and on-sale fields carry calendar dates, even when serialized as ISO timestamps.
  function formatCalendarDateLabel(value) {
    if (typeof value !== "string") return "TBD";

    var parts = /^(\d{4})-(\d{2})-(\d{2})(?:T(?:[01]\d|2[0-3]):[0-5]\d:[0-5]\d(?:\.\d+)?(?:Z|[+-](?:[01]\d|2[0-3]):[0-5]\d))?$/.exec(value);
    if (!parts) return "TBD";

    var date = new Date(parts[1] + "-" + parts[2] + "-" + parts[3] + "T00:00:00.000Z");
    if (Number.isNaN(date.getTime()) ||
        date.getUTCFullYear() !== Number(parts[1]) ||
        date.getUTCMonth() + 1 !== Number(parts[2]) ||
        date.getUTCDate() !== Number(parts[3])) return "TBD";

    return date.toLocaleDateString(undefined, {
      month: "short",
      day: "numeric",
      year: "numeric",
      timeZone: "UTC",
    });
  }

  // Activity and sync timestamps continue to display in the viewer's local time.
  function formatDateLabel(value) {
    if (!value) return "TBD";

    var date = new Date(value);
    if (Number.isNaN(date.getTime())) return "TBD";

    return date.toLocaleDateString(undefined, {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  }

  function formatMoney(value) {
    var amount = Number(value || 0);
    if (!Number.isFinite(amount) || amount <= 0) return null;

    return amount.toLocaleString(undefined, {
      style: "currency",
      currency: "USD",
    });
  }

  function getUiState(root) {
    if (!root.__darkstonePullListUi) {
      root.__darkstonePullListUi = {};
    }

    return root.__darkstonePullListUi;
  }

  function readQueryState() {
    var url = new URL(window.location.href);

    return {
      publisher: (url.searchParams.get("publisher") || "").trim(),
      sort: (url.searchParams.get("sort") || DEFAULT_SORT).trim() || DEFAULT_SORT,
      q: (url.searchParams.get("q") || "").trim(),
      view: (url.searchParams.get("discover") || url.searchParams.get("foc") || "").trim(),
    };
  }

  function buildPageHref(params) {
    var query = new URLSearchParams();

    if (params.publisher) query.set("publisher", params.publisher);
    if (params.sort && params.sort !== DEFAULT_SORT) query.set("sort", params.sort);
    if (params.q) query.set("q", params.q);
    // `view` is reserved by Shopify for alternate Liquid templates. Using it on
    // /pages/pull-list replaces the portal page before this script can mount.
    if (params.view) query.set("discover", params.view);

    var queryString = query.toString();
    return window.location.pathname + (queryString ? "?" + queryString : "");
  }

  function buildEndpointUrl(root, state) {
    var endpoint = root.getAttribute("data-endpoint") || "/apps/portal/pull-list";
    var url = new URL(endpoint, window.location.origin);

    if (state.publisher) url.searchParams.set("publisher", state.publisher);
    if (state.sort && state.sort !== DEFAULT_SORT) url.searchParams.set("sort", state.sort);
    if (state.q) url.searchParams.set("q", state.q);
    if (state.view) url.searchParams.set("view", state.view);

    return url.toString();
  }

  function getAvailability(release, reservationCutoffDays, serverDate) {
    if (!release || !release.focDate) {
      return {
        isOpen: false,
        label: "Date pending",
        detail: "Final-order cutoff has not been announced yet.",
        tone: "soon",
      };
    }

    var focDate = new Date(release.focDate);
    if (Number.isNaN(focDate.getTime())) {
      return {
        isOpen: false,
        label: "Date pending",
        detail: "Final-order cutoff has not been announced yet.",
        tone: "soon",
      };
    }

    var today = new Date(serverDate || Date.now());
    var timeDiff = focDate.getTime() - today.getTime();
    var daysUntilFoc = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));

    if (daysUntilFoc < reservationCutoffDays) {
      return {
        isOpen: false,
        label: "Window closed",
        detail: "Orders now close " + reservationCutoffDays + " day" + (reservationCutoffDays === 1 ? "" : "s") + " before FOC.",
        tone: "closed",
      };
    }

    if (daysUntilFoc <= reservationCutoffDays + 3) {
      var remainingDays = Math.max(daysUntilFoc - reservationCutoffDays, 0);
      return {
        isOpen: true,
        label: "Closing soon",
        detail: "Reserve within " + remainingDays + " day" + (remainingDays === 1 ? "" : "s") + ".",
        tone: "soon",
      };
    }

    return {
      isOpen: true,
      label: "Ordering open",
      detail: "Reserve before " + formatCalendarDateLabel(release.focDate) + ".",
      tone: "open",
    };
  }

  function getAnalyticsSessionKey() {
    var storageKey = "darkstone_pull_session";
    try {
      var existing = window.sessionStorage.getItem(storageKey);
      if (existing) return existing;
      var generated = window.crypto && window.crypto.randomUUID
        ? window.crypto.randomUUID()
        : "session-" + Date.now() + "-" + Math.random().toString(36).slice(2);
      window.sessionStorage.setItem(storageKey, generated);
      return generated;
    } catch (_error) {
      return "session-unavailable";
    }
  }

  function trackPullListEvent(root, eventType, metadata) {
    var endpoint = root.getAttribute("data-event-endpoint") || "/apps/portal/pull-list-event";
    var body = new URLSearchParams();
    body.set("eventType", eventType);
    body.set("source", "pull-list-page");
    body.set("sessionKey", getAnalyticsSessionKey());
    body.set("metadata", JSON.stringify(metadata || {}));

    fetch(endpoint, {
      method: "POST",
      credentials: "same-origin",
      keepalive: true,
      headers: { "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8" },
      body: body.toString(),
    }).catch(function () {});
  }

  function trackPullListEventOnce(root, eventType, metadata) {
    var key = "darkstone_pull_event_" + eventType;
    try {
      if (window.sessionStorage.getItem(key) === "1") return;
      window.sessionStorage.setItem(key, "1");
    } catch (_error) {}
    trackPullListEvent(root, eventType, metadata);
  }

  async function fetchPortalData(root, state) {
    var response = await fetch(buildEndpointUrl(root, state), {
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
      },
    });

    if (!response.ok) {
      throw new Error("Request failed with " + response.status);
    }

    return response.json();
  }

  async function submitPortalRequest(root, entries) {
    var endpoint = root.getAttribute("data-endpoint") || "/apps/portal/pull-list";
    var loginUrl = root.getAttribute("data-login-url") || "/account/login?return_url=%2Fpages%2Fpull-list";
    var body = new URLSearchParams();

    Object.keys(entries).forEach(function (key) {
      if (entries[key] == null) return;
      body.append(key, String(entries[key]));
    });

    var response = await fetch(endpoint, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
      body: body.toString(),
    });

    if (response.redirected && response.url.indexOf("/account/login") !== -1) {
      window.location.href = loginUrl;
      return null;
    }

    if (!response.ok) {
      var errorText = "";

      try {
        errorText = await response.text();
      } catch (_error) {
        errorText = "";
      }

      throw new Error(errorText || ("Request failed with " + response.status));
    }

    return fetchPortalData(root, readQueryState());
  }

  async function submitPortalAction(root, form) {
    var formData = new FormData(form);
    var entries = {};

    formData.forEach(function (value, key) {
      entries[key] = String(value);
    });

    if (entries.intent === "updateQuantity") {
      var quantity = Number.parseInt(entries.quantity || "1", 10);
      entries.quantity = String(!Number.isFinite(quantity) || quantity < 1 ? 1 : quantity);
    }

    return submitPortalRequest(root, entries);
  }

  function renderPublisherCard(entry, state) {
    return [
      '<a class="darkstone-pull-list__publisher-card" href="', escapeHtml(buildPageHref({
        publisher: entry.publisher,
        sort: state.sort,
        q: state.q,
      })), '">',
      '<span class="darkstone-pull-list__badge darkstone-pull-list__badge--publisher">', escapeHtml(String(entry.count || 0)), ' books</span>',
      '<h3 class="darkstone-pull-list__publisher-name">', escapeHtml(entry.publisher || "Unknown"), "</h3>",
      '<p class="darkstone-pull-list__publisher-copy">Browse upcoming releases from this publisher.</p>',
      '<div class="darkstone-pull-list__publisher-footer">',
      '<span class="darkstone-pull-list__publisher-cta">Browse publisher</span>',
      "</div>",
      "</a>",
    ].join("");
  }

  function renderVariant(variant, release, state, availability) {
    var variantPrice = formatMoney(variant.price);
    var previewTitle = variant.title || release.title || "Variant cover";
    var isReserved = Boolean(variant.reserved);
    var reservedLabel = "Reserved" + (variant.reservedQuantity ? " x" + String(variant.reservedQuantity) : "");
    var canReserve = Boolean(availability && availability.isOpen && !isReserved);

    return [
      '<article class="darkstone-pull-list__variant', isReserved ? " is-reserved" : "", '">',
      '<div class="darkstone-pull-list__variant-cover">',
      variant.coverImage
        ? '<button type="button" class="darkstone-pull-list__variant-preview-trigger" data-open-cover-preview="1" data-cover-src="' + escapeHtml(variant.coverImage) + '" data-cover-title="' + escapeHtml(previewTitle) + '"><img src="' + escapeHtml(variant.coverImage) + '" alt="' + escapeHtml(previewTitle) + '"></button>'
        : "",
      "</div>",
      "<div>",
      '<h4 class="darkstone-pull-list__variant-title">', escapeHtml(previewTitle), "</h4>",
      '<p class="darkstone-pull-list__variant-meta">',
      variantPrice ? "Cover " + escapeHtml(variantPrice) : "Cover price pending",
      isReserved ? ' <span class="darkstone-pull-list__badge darkstone-pull-list__badge--status is-open">' + escapeHtml(reservedLabel) + "</span>" : "",
      "</p>",
      '<form data-darkstone-portal-action method="post" action="/apps/portal/pull-list" style="margin-top:0.75rem">',
      '<input type="hidden" name="intent" value="add">',
      '<input type="hidden" name="title" value="', escapeHtml(variant.title || release.title || ""), '">',
      '<input type="hidden" name="publisher" value="', escapeHtml(release.publisher || state.publisher || "Unknown"), '">',
      '<input type="hidden" name="productMasterId" value="', escapeHtml(variant.id || ""), '">',
      '<input type="hidden" name="selectedPublisher" value="', escapeHtml(state.publisher || ""), '">',
      '<input type="hidden" name="sortOrder" value="', escapeHtml(state.sort || DEFAULT_SORT), '">',
      '<input type="hidden" name="searchQuery" value="', escapeHtml(state.q || ""), '">',
      '<input type="hidden" name="discoveryMode" value="', escapeHtml(state.view || ""), '">',
      '<button type="submit" class="darkstone-pull-list__button darkstone-pull-list__button--ghost"', canReserve ? "" : " disabled", ">",
      isReserved ? "Reserved" : availability && !availability.isOpen ? "Reservation closed" : "Reserve this cover",
      "</button>",
      "</form>",
      "</div>",
      "</article>",
    ].join("");
  }

  function renderCoverPreviewModal(uiState) {
    var preview = uiState.previewCover;
    if (!preview || !preview.src) return "";

    return [
      '<div class="darkstone-pull-list__modal" role="dialog" aria-modal="true" aria-label="Variant cover preview">',
      '<button type="button" class="darkstone-pull-list__modal-backdrop" data-close-cover-preview="1" aria-label="Close cover preview"></button>',
      '<div class="darkstone-pull-list__modal-dialog">',
      '<div class="darkstone-pull-list__modal-header">',
      '<p class="darkstone-pull-list__section-kicker">Cover preview</p>',
      '<button type="button" class="darkstone-pull-list__modal-close" data-close-cover-preview="1" aria-label="Close cover preview">Close</button>',
      "</div>",
      '<div class="darkstone-pull-list__modal-image-wrap">',
      '<img class="darkstone-pull-list__modal-image" src="', escapeHtml(preview.src), '" alt="', escapeHtml(preview.title || "Variant cover preview"), '">',
      "</div>",
      preview.title ? '<p class="darkstone-pull-list__modal-copy">' + escapeHtml(preview.title) + "</p>" : "",
      "</div>",
      "</div>",
    ].join("");
  }

  function renderPullItem(item, state) {
    var itemMeta = [];
    var isSeries = Boolean(item.isSeries);

    if (item.publisher) {
      itemMeta.push('<span class="darkstone-pull-list__badge darkstone-pull-list__badge--publisher">' + escapeHtml(item.publisher) + "</span>");
    }

    if (isSeries) {
      itemMeta.push('<span class="darkstone-pull-list__badge darkstone-pull-list__badge--status is-soon">Standing order</span>');
    } else if (item.issueNumber) {
      itemMeta.push('<span class="darkstone-pull-list__badge darkstone-pull-list__badge--status is-soon">Issue #' + escapeHtml(item.issueNumber) + "</span>");
      itemMeta.push('<span class="darkstone-pull-list__badge darkstone-pull-list__badge--status is-open">Qty ' + escapeHtml(String(item.quantity || 1)) + "</span>");
    }

    if (item.storeDate) {
      itemMeta.push('<span class="darkstone-pull-list__badge darkstone-pull-list__badge--status is-open">On sale ' + escapeHtml(formatCalendarDateLabel(item.storeDate)) + "</span>");
    }

    return [
      '<article class="darkstone-pull-list__manage-item">',
      '<div class="darkstone-pull-list__manage-cover">',
      item.coverImage
        ? '<img src="' + escapeHtml(item.coverImage) + '" alt="' + escapeHtml(item.title || "Pull list item") + '">'
        : '<div class="darkstone-pull-list__manage-fallback">' + escapeHtml(isSeries ? "Series" : "Issue") + "</div>",
      "</div>",
      '<div class="darkstone-pull-list__manage-body">',
      '<h4 class="darkstone-pull-list__manage-title">', escapeHtml(item.title || "Pull list item"), "</h4>",
      itemMeta.length ? '<div class="darkstone-pull-list__badge-row darkstone-pull-list__manage-meta">' + itemMeta.join("") + "</div>" : "",
      '<div class="darkstone-pull-list__manage-actions">',
      !isSeries ? [
        '<form data-darkstone-portal-action method="post" action="/apps/portal/pull-list" class="darkstone-pull-list__manage-row">',
        '<input type="hidden" name="intent" value="updateQuantity">',
        '<input type="hidden" name="itemId" value="', escapeHtml(item.id || ""), '">',
        '<input type="hidden" name="selectedPublisher" value="', escapeHtml(state.publisher || ""), '">',
        '<input type="hidden" name="sortOrder" value="', escapeHtml(state.sort || DEFAULT_SORT), '">',
        '<input type="hidden" name="searchQuery" value="', escapeHtml(state.q || ""), '">',
      '<input type="hidden" name="discoveryMode" value="', escapeHtml(state.view || ""), '">',
        '<div class="darkstone-pull-list__manage-quantity">',
        '<label class="darkstone-pull-list__manage-label" for="qty-', escapeHtml(item.id || "item"), '">Quantity</label>',
        '<input id="qty-', escapeHtml(item.id || "item"), '" class="darkstone-pull-list__input" type="number" min="1" step="1" name="quantity" value="', escapeHtml(String(item.quantity || 1)), '">',
        "</div>",
        '<button type="submit" class="darkstone-pull-list__button darkstone-pull-list__button--ghost">Update quantity</button>',
        "</form>",
      ].join("") : "",
      '<form data-darkstone-portal-action method="post" action="/apps/portal/pull-list">',
      '<input type="hidden" name="intent" value="removeItem">',
      '<input type="hidden" name="itemId" value="', escapeHtml(item.id || ""), '">',
      '<input type="hidden" name="selectedPublisher" value="', escapeHtml(state.publisher || ""), '">',
      '<input type="hidden" name="sortOrder" value="', escapeHtml(state.sort || DEFAULT_SORT), '">',
      '<input type="hidden" name="searchQuery" value="', escapeHtml(state.q || ""), '">',
      '<input type="hidden" name="discoveryMode" value="', escapeHtml(state.view || ""), '">',
      '<button type="submit" class="darkstone-pull-list__button darkstone-pull-list__button--danger">', escapeHtml(isSeries ? "Cancel subscription" : "Remove hold"), "</button>",
      "</form>",
      "</div>",
      "</div>",
      "</article>",
    ].join("");
  }

  function getVariantDetailsKey(release) {
    return [
      release.id,
      release.publisher,
      release.seriesTitle || release.title,
      release.issueNumber,
      release.focDate,
    ].filter(Boolean).join("|") || release.title || "release";
  }

  function renderReleaseCard(release, data, state, uiState) {
    var variants = Array.isArray(release.variants) ? release.variants : [];
    var primaryVariant = variants[0] || {};
    var availability = getAvailability(release, Number(data.reservationCutoffDays || 0), data.serverDate);
    var mainCoverPrice = formatMoney(primaryVariant.price);
    var primaryReserved = Boolean(primaryVariant.reserved);
    var alternateVariants = variants.slice(1);
    var variantDetailsKey = getVariantDetailsKey(release);
    var variantDetailsOpen = Boolean(uiState.openVariantDetails && uiState.openVariantDetails[variantDetailsKey]);

    return [
      '<article class="darkstone-pull-list__release">',
      '<div class="darkstone-pull-list__release-image">',
      primaryVariant.coverImage
        ? '<img src="' + escapeHtml(primaryVariant.coverImage) + '" alt="' + escapeHtml(release.title || "Upcoming release") + '">'
        : '<div class="darkstone-pull-list__release-fallback">' + escapeHtml(release.title || "Upcoming release") + "</div>",
      "</div>",
      '<div class="darkstone-pull-list__release-body">',
      '<div class="darkstone-pull-list__badge-row">',
      '<span class="darkstone-pull-list__badge darkstone-pull-list__badge--status is-' + escapeHtml(availability.tone) + '">',
      escapeHtml(availability.label),
      "</span>",
      release.issueNumber
        ? '<span class="darkstone-pull-list__badge darkstone-pull-list__badge--publisher">Issue #' + escapeHtml(release.issueNumber) + "</span>"
        : "",
      "</div>",
      '<h3 class="darkstone-pull-list__release-title">', escapeHtml(release.title || "Upcoming release"), "</h3>",
      '<p class="darkstone-pull-list__release-copy">', escapeHtml(availability.detail), "</p>",
      '<p class="darkstone-pull-list__meta"><strong>FOC ', escapeHtml(formatCalendarDateLabel(release.focDate)), "</strong>",
      mainCoverPrice ? " | Main cover " + escapeHtml(mainCoverPrice) : "",
      " | " + escapeHtml(variants.length > 1 ? variants.length + " cover options" : "Single cover"),
      "</p>",
      '<div class="darkstone-pull-list__release-actions">',
      '<form data-darkstone-portal-action method="post" action="/apps/portal/pull-list">',
      '<input type="hidden" name="intent" value="add">',
      '<input type="hidden" name="title" value="', escapeHtml(primaryVariant.title || release.title || ""), '">',
      '<input type="hidden" name="publisher" value="', escapeHtml(release.publisher || state.publisher || "Unknown"), '">',
      '<input type="hidden" name="productMasterId" value="', escapeHtml(primaryVariant.id || release.id || ""), '">',
      '<input type="hidden" name="selectedPublisher" value="', escapeHtml(state.publisher || ""), '">',
      '<input type="hidden" name="sortOrder" value="', escapeHtml(state.sort || DEFAULT_SORT), '">',
      '<input type="hidden" name="searchQuery" value="', escapeHtml(state.q || ""), '">',
      '<input type="hidden" name="discoveryMode" value="', escapeHtml(state.view || ""), '">',
      '<button type="submit" class="darkstone-pull-list__button darkstone-pull-list__button--primary"', availability.isOpen && !primaryReserved ? "" : " disabled", ">",
      primaryReserved
        ? "Reserved" + (primaryVariant.reservedQuantity ? " x" + escapeHtml(String(primaryVariant.reservedQuantity)) : "")
        : availability.isOpen ? "Add main cover" : "Reservation closed",
      "</button>",
      "</form>",
      '<form data-darkstone-portal-action method="post" action="/apps/portal/pull-list">',
      '<input type="hidden" name="intent" value="subscribeSeries">',
      '<input type="hidden" name="seriesTitle" value="', escapeHtml(release.seriesTitle || release.title || ""), '">',
      '<input type="hidden" name="publisher" value="', escapeHtml(release.publisher || state.publisher || "Unknown"), '">',
      '<input type="hidden" name="selectedPublisher" value="', escapeHtml(state.publisher || ""), '">',
      '<input type="hidden" name="sortOrder" value="', escapeHtml(state.sort || DEFAULT_SORT), '">',
      '<input type="hidden" name="searchQuery" value="', escapeHtml(state.q || ""), '">',
      '<input type="hidden" name="discoveryMode" value="', escapeHtml(state.view || ""), '">',
      '<button type="submit" class="darkstone-pull-list__button darkstone-pull-list__button--ghost">Subscribe to series</button>',
      "</form>",
      "</div>",
      alternateVariants.length ? [
        '<details class="darkstone-pull-list__details" data-variant-details="', escapeHtml(variantDetailsKey), '"', variantDetailsOpen ? " open" : "", ">",
        "<summary>View alternate covers (" + escapeHtml(String(alternateVariants.length)) + ")</summary>",
        '<div class="darkstone-pull-list__variant-list">',
        alternateVariants.map(function (variant) { return renderVariant(variant, release, state, availability); }).join(""),
        "</div>",
        "</details>",
      ].join("") : "",
      "</div>",
      "</article>",
    ].join("");
  }

  function renderManageColumn(key, title, items, state, emptyMessage, uiState) {
    var isOpen = Boolean(uiState[key]);
    var itemCount = items.length;
    var countLabel = itemCount + " item" + (itemCount === 1 ? "" : "s");

    return [
      '<article class="darkstone-pull-list__card darkstone-pull-list__manage-card',
      isOpen ? " is-open" : " is-collapsed",
      '">',
      '<p class="darkstone-pull-list__section-kicker">Current pull list</p>',
      '<button type="button" class="darkstone-pull-list__manage-toggle" data-toggle-pull-section="', escapeHtml(key), '" aria-expanded="', isOpen ? "true" : "false", '">',
      '<span class="darkstone-pull-list__manage-toggle-heading">',
      '<span class="darkstone-pull-list__card-title">', escapeHtml(title), "</span>",
      '<span class="darkstone-pull-list__manage-count">', escapeHtml(countLabel), "</span>",
      "</span>",
      '<span class="darkstone-pull-list__manage-toggle-copy">', isOpen ? "Hide" : "Show", "</span>",
      "</button>",
      '<div class="darkstone-pull-list__manage-panel"', isOpen ? "" : " hidden", ">",
      itemCount
        ? '<div class="darkstone-pull-list__manage-list">' + items.map(function (item) { return renderPullItem(item, state); }).join("") + "</div>"
        : '<div class="darkstone-pull-list__empty darkstone-pull-list__manage-empty">' + escapeHtml(emptyMessage) + "</div>",
      "</div>",
      "</article>",
    ].join("");
  }

  function renderPullHistoryItem(item) {
    var itemMeta = [];
    var historicalDate = item.storeDate || item.createdAt;
    var historicalDateLabel = item.storeDate ? "Reserved for " : "Reserved on ";

    if (item.publisher) {
      itemMeta.push('<span class="darkstone-pull-list__badge darkstone-pull-list__badge--publisher">' + escapeHtml(item.publisher) + "</span>");
    }
    if (item.issueNumber) {
      itemMeta.push('<span class="darkstone-pull-list__badge darkstone-pull-list__badge--status is-soon">Issue #' + escapeHtml(item.issueNumber) + "</span>");
    }
    if (Number(item.quantity) > 1) {
      itemMeta.push('<span class="darkstone-pull-list__badge darkstone-pull-list__badge--status is-open">Qty ' + escapeHtml(String(item.quantity)) + "</span>");
    }

    return [
      '<article class="darkstone-pull-list__manage-item">',
      '<div class="darkstone-pull-list__manage-cover">',
      item.coverImage
        ? '<img src="' + escapeHtml(item.coverImage) + '" alt="' + escapeHtml(item.title || "Historical reservation") + '">'
        : '<div class="darkstone-pull-list__manage-fallback">History</div>',
      "</div>",
      '<div class="darkstone-pull-list__manage-body">',
      '<h4 class="darkstone-pull-list__manage-title">' + escapeHtml(item.title || "Historical reservation") + "</h4>",
      itemMeta.length ? '<div class="darkstone-pull-list__badge-row darkstone-pull-list__manage-meta">' + itemMeta.join("") + "</div>" : "",
      '<p class="darkstone-pull-list__copy">' + (historicalDate ? historicalDateLabel + escapeHtml(item.storeDate ? formatCalendarDateLabel(item.storeDate) : formatDateLabel(item.createdAt)) : "Past reservation") + "</p>",
      "</div>",
      "</article>",
    ].join("");
  }

  function renderPullHistorySection(items, totalCount, shouldOpen) {
    var visibleItems = items.slice(0, MAX_VISIBLE_PULL_HISTORY);
    if (totalCount === 0) return "";

    return [
      '<section class="darkstone-pull-list__section">',
      '<details id="reservation-history" class="darkstone-pull-list__details"' + (shouldOpen ? " open" : "") + '>',
      '<summary>Reservation history (' + escapeHtml(String(totalCount)) + ")</summary>",
      '<p class="darkstone-pull-list__copy">Past reservations are read-only here. Current upcoming reservations remain editable above.</p>',
      '<div class="darkstone-pull-list__manage-list">' + visibleItems.map(renderPullHistoryItem).join("") + "</div>",
      totalCount > visibleItems.length ? '<p class="darkstone-pull-list__copy">Showing ' + visibleItems.length + " of " + totalCount + " historical reservations.</p>" : "",
      "</details>",
      "</section>",
    ].join("");
  }

  function renderPullListDataLimitNotice(data) {
    if (!data.pullListDataTruncated) return "";

    return [
      '<div class="darkstone-pull-list__data-warning" role="status">',
      '<strong>Some reservations aren\'t shown.</strong> ',
      'This account has more pull-list data than can safely load at once. Contact Darkstone to review the complete current and historical list.',
      "</div>",
    ].join("");
  }

  function renderGuestPreviewCard(release, loginUrl) {
    var variants = Array.isArray(release.variants) ? release.variants : [];
    var cover = variants[0] && variants[0].coverImage;
    return [
      '<article class="darkstone-pull-list__release ds-pull-preview-card">',
      '<div class="darkstone-pull-list__release-image">',
      cover
        ? '<img src="' + escapeHtml(cover) + '" alt="' + escapeHtml(release.title || "Upcoming comic") + '">'
        : '<div class="darkstone-pull-list__release-fallback">Upcoming comic</div>',
      "</div>",
      '<div class="darkstone-pull-list__release-body">',
      '<span class="darkstone-pull-list__badge darkstone-pull-list__badge--status is-soon">FOC ' + escapeHtml(formatCalendarDateLabel(release.focDate)) + "</span>",
      '<h3 class="darkstone-pull-list__release-title">' + escapeHtml(release.title || "Upcoming comic") + "</h3>",
      '<a class="darkstone-pull-list__link darkstone-pull-list__button--primary" data-pull-auth-start href="' + escapeHtml(loginUrl) + '">Sign in to reserve</a>',
      "</div>",
      "</article>",
    ].join("");
  }

  function renderGuestState(root, data, notice, error) {
    var loginUrl = root.getAttribute("data-login-url") || "/account/login?return_url=%2Fpages%2Fpull-list";
    var releases = Array.isArray(data.upcomingReleases) ? data.upcomingReleases.slice(0, 12) : [];
    var uiState = getUiState(root);
    uiState.previewCover = null;
    root.__darkstonePullListMessages = {
      notice: notice || "",
      error: error || "",
    };
    document.body.classList.remove("darkstone-pull-list-modal-open");

    root.innerHTML = [
      notice ? '<div class="darkstone-pull-list__notice">' + escapeHtml(notice) + "</div>" : "",
      error ? '<div class="darkstone-pull-list__error">' + escapeHtml(error) + "</div>" : "",
      '<section class="darkstone-pull-list__hero ds-pull-guest-prompt">',
      "<div>",
      '<p class="darkstone-pull-list__kicker">Upcoming comics</p>',
      '<h2 class="darkstone-pull-list__title">Preview first. Sign in when you are ready to reserve.</h2>',
      '<p class="darkstone-pull-list__copy">The books below are approaching Darkstone’s next reservation cutoff. Signing in connects selections to your customer account.</p>',
      '<div class="darkstone-pull-list__actions">',
      '<a class="darkstone-pull-list__link darkstone-pull-list__button--primary" data-pull-auth-start href="' + escapeHtml(loginUrl) + '">Start my pull list</a>',
      '<a class="darkstone-pull-list__link darkstone-pull-list__link--ghost" href="/collections/comics">Shop available comics</a>',
      "</div>",
      "</div>",
      '<aside class="darkstone-pull-list__snapshot">',
      '<p><strong>' + escapeHtml(String(data.nextFocReleaseCount || releases.length)) + "</strong> comic group" + (Number(data.nextFocReleaseCount || releases.length) === 1 ? "" : "s") + " are due in the next cutoff view.</p>",
      data.nextFocDate ? "<p>Next displayed FOC: <strong>" + escapeHtml(formatCalendarDateLabel(data.nextFocDate)) + "</strong>.</p>" : "",
      "<p>No reservation is created until you sign in and choose an issue or series.</p>",
      "</aside>",
      "</section>",
      '<section class="darkstone-pull-list__section">',
      '<div class="darkstone-pull-list__toolbar"><div>',
      '<p class="darkstone-pull-list__section-kicker">Preview upcoming comics</p>',
      '<h2 class="darkstone-pull-list__section-title">Books closing next</h2>',
      '<p class="darkstone-pull-list__copy">Browse real upcoming catalog entries before creating or signing into an account.</p>',
      "</div></div>",
      releases.length
        ? '<div class="darkstone-pull-list__release-grid ds-pull-preview-grid">' + releases.map(function (release) { return renderGuestPreviewCard(release, loginUrl); }).join("") + "</div>"
        : '<div class="darkstone-pull-list__empty">No upcoming preview is available right now. Please check back after the next catalog import.</div>',
      "</section>",
    ].join("");
  }

  function renderDiscoverySection(data, state, publishers, releases, uiState) {
    var selectedPublisher = data.selectedPublisher || state.publisher || "";
    var hasBrowseView = Boolean(selectedPublisher || state.view || state.q);
    var browseLabel = selectedPublisher
      ? selectedPublisher
      : state.view === "new1"
        ? "New series and issue #1"
        : state.view === "next"
          ? "Books closing next"
          : "Search results";

    var discoveryForm = [
      '<div class="darkstone-pull-list__card darkstone-pull-list__filter ds-pull-global-search">',
      '<form method="get" action="' + escapeHtml(window.location.pathname) + '">',
      '<label class="darkstone-pull-list__manage-label" for="darkstone-pull-global-search">Search every upcoming title</label>',
      '<div class="darkstone-pull-list__filter-row">',
      '<input id="darkstone-pull-global-search" class="darkstone-pull-list__input" type="search" name="q" value="' + escapeHtml(data.searchQuery || state.q || "") + '" placeholder="Try Absolute Batman or Spider-Man">',
      '<select class="darkstone-pull-list__select" name="sort" aria-label="Sort upcoming comics">',
      '<option value="foc-soon"' + (data.sortOrder === "foc-soon" ? " selected" : "") + ">Closing soon</option>",
      '<option value="foc-late"' + (data.sortOrder === "foc-late" ? " selected" : "") + ">Closing later</option>",
      '<option value="title-az"' + (data.sortOrder === "title-az" ? " selected" : "") + ">Title A-Z</option>",
      '<option value="title-za"' + (data.sortOrder === "title-za" ? " selected" : "") + ">Title Z-A</option>",
      "</select>",
      '<button class="darkstone-pull-list__button darkstone-pull-list__button--primary" type="submit">Search</button>',
      "</div>",
      "</form>",
      '<div class="ds-pull-discovery-links">',
      '<a class="darkstone-pull-list__link darkstone-pull-list__link--ghost" href="' + escapeHtml(buildPageHref({ view: "next", sort: "foc-soon" })) + '">Closing next</a>',
      '<a class="darkstone-pull-list__link darkstone-pull-list__link--ghost" href="' + escapeHtml(buildPageHref({ view: "new1", sort: "foc-soon" })) + '">New #1 issues</a>',
      hasBrowseView ? '<a class="darkstone-pull-list__link darkstone-pull-list__link--ghost" href="' + escapeHtml(buildPageHref({ sort: DEFAULT_SORT })) + '">Browse publishers</a>' : "",
      "</div>",
      "</div>",
    ].join("");

    if (!hasBrowseView) {
      return [
        '<section class="darkstone-pull-list__section darkstone-pull-list__browse-section">',
        '<p class="darkstone-pull-list__section-kicker">Find your next comic</p>',
        '<h3 class="darkstone-pull-list__section-title">Search, catch the next cutoff, or browse a publisher</h3>',
        '<p class="darkstone-pull-list__copy">You do not need to know the publisher first. Search a title across the full upcoming catalog.</p>',
        discoveryForm,
        '<h3 class="darkstone-pull-list__section-title ds-pull-publisher-heading">Browse by publisher</h3>',
        publishers.length
          ? '<div class="darkstone-pull-list__publisher-grid">' + publishers.map(function (entry) { return renderPublisherCard(entry, state); }).join("") + "</div>"
          : '<div class="darkstone-pull-list__empty">No publisher shelves are live yet. New upcoming comics appear after catalog imports.</div>',
        "</section>",
      ].join("");
    }

    return [
      '<section class="darkstone-pull-list__section darkstone-pull-list__browse-section">',
      '<div class="darkstone-pull-list__toolbar"><div>',
      '<p class="darkstone-pull-list__section-kicker">Upcoming catalog</p>',
      '<h3 class="darkstone-pull-list__section-title">' + escapeHtml(browseLabel) + "</h3>",
      '<p class="darkstone-pull-list__copy">Showing ' + escapeHtml(String(releases.length)) + " matching release group" + (releases.length === 1 ? "" : "s") + ". Reserve one issue or follow the canonical series.</p>",
      "</div></div>",
      discoveryForm,
      releases.length
        ? '<div class="darkstone-pull-list__release-grid">' + releases.map(function (release) { return renderReleaseCard(release, data, state, uiState); }).join("") + "</div>"
        : '<div class="darkstone-pull-list__empty">No books match this view right now. Try a shorter title or reset the view.</div>',
      "</section>",
    ].join("");
  }

  function renderCommunicationPreferences(data) {
    var preferences = data.communicationPreferences || {};
    function preferenceRow(name, label, copy) {
      return [
        '<label class="ds-pull-preference">',
        '<input type="checkbox" name="' + name + '" value="true"' + (preferences[name] ? " checked" : "") + '>',
        '<span><strong>' + escapeHtml(label) + '</strong><small>' + escapeHtml(copy) + "</small></span>",
        "</label>",
      ].join("");
    }

    return [
      '<section class="darkstone-pull-list__section">',
      '<div class="darkstone-pull-list__card ds-pull-preferences">',
      '<p class="darkstone-pull-list__section-kicker">Optional updates</p>',
      '<h3 class="darkstone-pull-list__section-title">Choose which pull-list emails you want</h3>',
      '<p class="darkstone-pull-list__copy">All options are off until you select them. You can change them here at any time.</p>',
      '<form data-darkstone-portal-action method="post" action="/apps/portal/pull-list">',
      '<input type="hidden" name="intent" value="updateCommunicationPreferences">',
      '<div class="ds-pull-preference-grid">',
      preferenceRow("confirmationEmail", "Reservation confirmations", "A short confirmation after you reserve an issue or follow a series."),
      preferenceRow("weeklyDigestEmail", "Weekly pull-list snapshot", "A weekly summary of active reservations and standing series."),
      preferenceRow("readyForPickupEmail", "Ready-for-pickup updates", "Future ready-item alerts when Darkstone marks pull-list allocations ready."),
      preferenceRow("seriesSuggestionEmail", "Series follow suggestions", "Future reminders when a recent issue has a canonical series you can follow."),
      "</div>",
      '<button class="darkstone-pull-list__button darkstone-pull-list__button--primary" type="submit">Save email preferences</button>',
      "</form>",
      "</div>",
      "</section>",
    ].join("");
  }

  function renderPortal(root, data, state, notice, error) {
    var customerName = escapeHtml((data.customer && data.customer.firstName) || "Collector");
    var selectedPublisher = data.selectedPublisher || "";
    var publishers = Array.isArray(data.publishers) ? data.publishers : [];
    var releases = Array.isArray(data.upcomingReleases) ? data.upcomingReleases : [];
    var activePullItems = Array.isArray(data.activePullItems) ? data.activePullItems : [];
    var pullHistoryItems = Array.isArray(data.pullHistoryItems) ? data.pullHistoryItems : [];
    var pullHistoryCount = Math.max(pullHistoryItems.length, Number(data.summary && data.summary.historyCount) || 0);
    var seriesSubscriptionCount = Number(data.seriesSubscriptionCount || 0);
    var reservedIssueItems = activePullItems.filter(function (item) { return !item.isSeries; });
    var reservedSeriesItems = activePullItems.filter(function (item) { return item.isSeries; });
    var hasSelectedPublisher = Boolean(selectedPublisher);
    var uiState = getUiState(root);
    var historyRequested = window.location.hash === "#reservation-history" && !uiState.historyDeepLinkConsumed;
    if (historyRequested) {
      uiState.historyDeepLinkConsumed = true;
      uiState.historyOpen = true;
    }
    var historyShouldOpen = Boolean(uiState.historyOpen);

    if (typeof uiState.reservedBooks === "undefined") {
      uiState.reservedBooks = reservedIssueItems.length === 0;
    }

    if (typeof uiState.seriesSubscriptions === "undefined") {
      uiState.seriesSubscriptions = reservedSeriesItems.length === 0;
    }

    uiState.openVariantDetails = uiState.openVariantDetails || {};

    root.__darkstonePullListMessages = {
      notice: notice || "",
      error: error || "",
    };
    document.body.classList.toggle("darkstone-pull-list-modal-open", Boolean(uiState.previewCover && uiState.previewCover.src));

    root.innerHTML = [
      notice ? '<div class="darkstone-pull-list__notice">' + escapeHtml(notice) + "</div>" : "",
      error ? '<div class="darkstone-pull-list__error">' + escapeHtml(error) + "</div>" : "",
      '<section class="darkstone-pull-list__hero">',
      "<div>",
      '<p class="darkstone-pull-list__kicker">Darkstone Pull List</p>',
      '<h2 class="darkstone-pull-list__title">',
      hasSelectedPublisher ? "Reserve " + escapeHtml(selectedPublisher) + " books." : "Browse this week's publisher shelves.",
      "</h2>",
      '<p class="darkstone-pull-list__copy">',
      hasSelectedPublisher
        ? "Welcome back, " + customerName + ". Reserve the main cover fast, then open alternate covers when you want a specific variant."
        : "Welcome back, " + customerName + ". Start with the publishers below, reserve books before FOC, and manage your current holds without leaving the storefront.",
      "</p>",
      '<div class="darkstone-pull-list__chips">',
      '<span class="darkstone-pull-list__chip">Reservations close ' + escapeHtml(String(data.reservationCutoffDays || 0)) + " day" + (Number(data.reservationCutoffDays || 0) === 1 ? "" : "s") + " before FOC</span>",
      '<span class="darkstone-pull-list__chip">' + escapeHtml(String(data.activePullCount || 0)) + " active pull-list item" + (Number(data.activePullCount || 0) === 1 ? "" : "s") + "</span>",
      '<span class="darkstone-pull-list__chip">' + escapeHtml(String(data.seriesSubscriptionCount || 0)) + " active series subscription" + (Number(data.seriesSubscriptionCount || 0) === 1 ? "" : "s") + "</span>",
      "</div>",
      '<div class="darkstone-pull-list__actions">',
      '<a class="darkstone-pull-list__link darkstone-pull-list__button--primary" href="/apps/portal/my-darkstone">My Darkstone</a>',
      '<a class="darkstone-pull-list__link darkstone-pull-list__link--ghost" href="/apps/portal/guild-ledger">Guild ledger</a>',
      '<a class="darkstone-pull-list__link darkstone-pull-list__link--ghost" href="/pages/events">Events and tickets</a>',
      "</div>",
      "</div>",
      '<aside class="darkstone-pull-list__snapshot">',
      "<p><strong>" + escapeHtml(String(seriesSubscriptionCount)) + "</strong> series subscription" + (seriesSubscriptionCount === 1 ? "" : "s") + (seriesSubscriptionCount === 1 ? " is" : " are") + " active on your pull list.</p>",
      "<p><strong>" + escapeHtml(String(pullHistoryCount)) + "</strong> past reservation" + (pullHistoryCount === 1 ? "" : "s") + (pullHistoryCount === 1 ? " is" : " are") + " available in your history.</p>",
      "<p><strong>" + escapeHtml(formatDateLabel(data.serverDate)) + "</strong> is the storefront sync date for this browsing session.</p>",
      hasSelectedPublisher
        ? "<p>Reserve books from this publisher, then update your holds right below.</p>"
        : "<p>Pick a publisher first or update the active holds already tied to your account.</p>",
      hasSelectedPublisher
        ? '<a class="darkstone-pull-list__link darkstone-pull-list__link--ghost" href="' + escapeHtml(buildPageHref({ sort: state.sort, q: state.q })) + '">Back to publishers</a>'
        : "",
      "</aside>",
      "</section>",

      activePullItems.length === 0 && pullHistoryCount === 0
        ? [
            '<section class="darkstone-pull-list__section ds-pull-empty-guide" aria-labelledby="ds-pull-first-item-title">',
            '<p class="darkstone-pull-list__section-kicker">First reservation</p>',
            '<h2 id="ds-pull-first-item-title" class="darkstone-pull-list__section-title">Your pull list is ready—add your first book.</h2>',
            '<p class="darkstone-pull-list__copy">Search a title, open the books closing next, or browse a publisher. One successful reservation activates the list; there are no extra setup steps.</p>',
            '<div class="ds-pull-discovery-links">',
            '<a class="darkstone-pull-list__link darkstone-pull-list__button--primary" href="#darkstone-pull-global-search">Search for a series</a>',
            '<a class="darkstone-pull-list__link darkstone-pull-list__link--ghost" href="' + escapeHtml(buildPageHref({ view: "next", sort: "foc-soon" })) + '">Browse books closing soon</a>',
            '<a class="darkstone-pull-list__link darkstone-pull-list__link--ghost" href="/pages/contact">Ask Darkstone staff</a>',
            "</div>",
            "</section>",
          ].join("")
        : "",

      activePullItems.length === 0 && pullHistoryCount > 0
        ? [
            '<section class="darkstone-pull-list__section ds-pull-empty-guide">',
            '<p class="darkstone-pull-list__section-kicker">Between releases</p>',
            '<h2 class="darkstone-pull-list__section-title">No upcoming reservations right now.</h2>',
            '<p class="darkstone-pull-list__copy">You are still a returning pull-list customer. Your reservation history is available below, and new upcoming books can be added whenever you are ready.</p>',
            "</section>",
          ].join("")
        : "",

      renderPullListDataLimitNotice(data),

      '<section class="darkstone-pull-list__section">',
      '<div class="darkstone-pull-list__toolbar">',
      "<div>",
      '<p class="darkstone-pull-list__section-kicker">Current pull list</p>',
      '<h3 class="darkstone-pull-list__section-title">Reserved books and active series</h3>',
      '<p class="darkstone-pull-list__copy">Open either box when you want to update quantities, remove holds, or review your always-on subscriptions.</p>',
      '<div class="darkstone-pull-list__badge-row darkstone-pull-list__toolbar-chips">',
      '<span class="darkstone-pull-list__chip">' + escapeHtml(String(reservedIssueItems.length)) + " reserved book" + (reservedIssueItems.length === 1 ? "" : "s") + "</span>",
      '<span class="darkstone-pull-list__chip">' + escapeHtml(String(reservedSeriesItems.length)) + " series subscription" + (reservedSeriesItems.length === 1 ? "" : "s") + "</span>",
      '<span class="darkstone-pull-list__chip">' + escapeHtml(String(data.activePullCount || 0)) + " total active item" + (Number(data.activePullCount || 0) === 1 ? "" : "s") + "</span>",
      "</div>",
      "</div>",
      "</div>",
      '<div class="darkstone-pull-list__manage-grid">',
      renderManageColumn("reservedBooks", "Reserved books", reservedIssueItems, state, "No current reserved books are on this pull list yet.", uiState),
      renderManageColumn("seriesSubscriptions", "Series subscriptions", reservedSeriesItems, state, "No active series subscriptions are on this pull list yet.", uiState),
      "</div>",
      "</section>",

      renderPullHistorySection(pullHistoryItems, pullHistoryCount, historyShouldOpen),
      renderCommunicationPreferences(data),
      renderDiscoverySection(data, state, publishers, releases, uiState),
      renderCoverPreviewModal(uiState),
    ].join("");

    if (historyRequested) {
      window.requestAnimationFrame(function () {
        var historySection = document.getElementById("reservation-history");
        if (!historySection) return;
        historySection.scrollIntoView({ block: "start" });
        var historySummary = historySection.querySelector("summary");
        if (historySummary) historySummary.focus({ preventScroll: true });
      });
    }
  }

  function renderLoadError(root, message) {
    var uiState = getUiState(root);
    uiState.previewCover = null;
    root.__darkstonePullListMessages = {
      notice: "",
      error: message || "",
    };
    document.body.classList.remove("darkstone-pull-list-modal-open");

    root.innerHTML = [
      '<div class="darkstone-pull-list__error">',
      escapeHtml(message),
      "</div>",
      '<div class="darkstone-pull-list__notice">Refresh the page in a moment. If the problem persists, the app deployment and theme publish step may be out of sync.</div>',
    ].join("");
  }

  function syncLandingOnboarding(root, data) {
    var section = root.closest(".darkstone-pull-list-pulse-section");
    if (!section) return;

    var activePullCount = Number(data.activePullCount || 0);
    var seriesSubscriptionCount = Number(data.seriesSubscriptionCount || 0);
    var activePullItems = Array.isArray(data.activePullItems) ? data.activePullItems : [];
    var pullHistoryItems = Array.isArray(data.pullHistoryItems) ? data.pullHistoryItems : [];
    var historyCount = Number(data.summary && data.summary.historyCount || 0);
    var hasEstablishedPullList = activePullCount > 0
      || seriesSubscriptionCount > 0
      || activePullItems.length > 0
      || pullHistoryItems.length > 0
      || historyCount > 0;
    var hideOnboarding = Boolean(!data.requiresLogin && hasEstablishedPullList);
    section.querySelectorAll("[data-pull-onboarding]").forEach(function (element) {
      element.hidden = hideOnboarding;
      element.style.display = hideOnboarding ? "none" : "";
    });

    var authStart = section.querySelector("[data-pull-auth-start]");
    if (!authStart) return;

    if (data.requiresLogin) {
      authStart.setAttribute("href", root.getAttribute("data-login-url") || "/account/login");
      authStart.textContent = "Start my pull list";
      return;
    }

    authStart.setAttribute("href", "#darkstone-pull-list-browser");
    authStart.textContent = "Browse upcoming comics";
  }

  async function refresh(root, options) {
    options = options || {};
    root.innerHTML = '<div class="darkstone-pull-list__loading">Loading the Darkstone pull list portal...</div>';

    try {
      var data = await fetchPortalData(root, readQueryState());
      root.__darkstonePullListData = data;
      root.__darkstonePullListState = readQueryState();
      syncLandingOnboarding(root, data);

      if (data.requiresLogin) {
        trackPullListEventOnce(root, "pull_landing_view", { view: readQueryState().view || "landing" });
        renderGuestState(root, data, options.notice, options.error);
        return;
      }

      trackPullListEventOnce(root, "pull_auth_complete", { placement: "pull-list-page" });
      renderPortal(root, data, readQueryState(), options.notice, options.error);
    } catch (error) {
      renderLoadError(root, error && error.message ? error.message : "We could not load the pull list right now.");
    }
  }

  function getSuccessNotice(form) {
    var intent = form.querySelector('input[name="intent"]');
    var title = form.querySelector('input[name="title"]');
    var seriesTitle = form.querySelector('input[name="seriesTitle"]');

    if (!intent) return "Your pull list was updated.";
    if (intent.value === "subscribeSeries" || intent.value === "subscribeSeriesBySku") {
      return (seriesTitle && seriesTitle.value ? seriesTitle.value : "This series") + " is now on your pull list.";
    }
    if (intent.value === "updateCommunicationPreferences") {
      return "Email preferences saved.";
    }
    if (intent.value === "updateQuantity") {
      return "Quantity updated.";
    }
    if (intent.value === "removeItem") {
      return "Pull list item removed.";
    }

    return (title && title.value ? title.value : "That issue") + " was added to your pull list.";
  }

  function getPendingLabel(form) {
    var intent = form.querySelector('input[name="intent"]');
    if (!intent) return "Saving...";
    if (intent.value === "subscribeSeries" || intent.value === "subscribeSeriesBySku") return "Following...";
    if (intent.value === "updateCommunicationPreferences") return "Saving preferences...";
    if (intent.value === "updateQuantity") return "Updating...";
    if (intent.value === "removeItem") return "Removing...";
    return "Adding...";
  }

  function setActionPending(form) {
    var button = form.querySelector('button[type="submit"]');
    if (!button) return function () {};

    var originalHtml = button.innerHTML;
    var originalDisabled = button.disabled;
    button.disabled = true;
    button.setAttribute("aria-busy", "true");
    button.innerHTML = getPendingLabel(form);

    return function () {
      button.disabled = originalDisabled;
      button.removeAttribute("aria-busy");
      button.innerHTML = originalHtml;
    };
  }

  function captureScrollPosition() {
    return {
      x: window.pageXOffset || document.documentElement.scrollLeft || 0,
      y: window.pageYOffset || document.documentElement.scrollTop || 0,
    };
  }

  function restoreScrollPosition(position) {
    if (!position) return;
    window.requestAnimationFrame(function () {
      window.scrollTo(position.x, position.y);
    });
  }

  function bindRoot(root) {
    if (root.__darkstonePullListBound) return;
    root.__darkstonePullListBound = true;

    root.addEventListener("toggle", function (event) {
      var details = event.target;
      if (!(details instanceof HTMLDetailsElement)) return;

      var uiState = getUiState(root);
      if (details.id === "reservation-history") {
        uiState.historyOpen = details.open;
        return;
      }

      if (!details.hasAttribute("data-variant-details")) return;

      var detailsKey = details.getAttribute("data-variant-details");
      if (!detailsKey) return;

      uiState.openVariantDetails = uiState.openVariantDetails || {};
      if (details.open) {
        uiState.openVariantDetails[detailsKey] = true;
      } else {
        delete uiState.openVariantDetails[detailsKey];
      }
    }, true);

    root.addEventListener("submit", function (event) {
      var form = event.target;
      if (!(form instanceof HTMLFormElement) || !form.hasAttribute("data-darkstone-portal-action")) {
        return;
      }

      event.preventDefault();

      var submittedIntent = form.querySelector('input[name="intent"]');
      if (submittedIntent && (submittedIntent.value === "add" || submittedIntent.value === "subscribeSeries" || submittedIntent.value === "subscribeSeriesBySku")) {
        trackPullListEvent(root, "pull_list_cta_click", { intent: submittedIntent.value, placement: "portal-card" });
      }

      if (root.getAttribute("data-busy") === "1") {
        return;
      }

      root.setAttribute("data-busy", "1");
      var restoreActionButton = setActionPending(form);
      var scrollPosition = captureScrollPosition();
      var openVariantDetails = form.closest("details[data-variant-details]");
      if (openVariantDetails) {
        var openDetailsKey = openVariantDetails.getAttribute("data-variant-details");
        if (openDetailsKey) {
          var uiState = getUiState(root);
          uiState.openVariantDetails = uiState.openVariantDetails || {};
          uiState.openVariantDetails[openDetailsKey] = true;
        }
      }

      submitPortalAction(root, form)
        .then(function (data) {
          root.removeAttribute("data-busy");
          restoreActionButton();
          if (!data) return;

          root.__darkstonePullListData = data;
          root.__darkstonePullListState = readQueryState();
          renderPortal(root, data, readQueryState(), getSuccessNotice(form), "");
          restoreScrollPosition(scrollPosition);
        })
        .catch(function (error) {
          root.removeAttribute("data-busy");
          restoreActionButton();
          refresh(root, {
            error: error && error.message ? error.message : "We could not update the pull list right now.",
          });
        });
    });

    root.addEventListener("click", function (event) {
      var authStart = event.target instanceof Element ? event.target.closest("[data-pull-auth-start]") : null;
      if (authStart && root.contains(authStart)) {
        trackPullListEvent(root, "pull_auth_start", { placement: "portal-preview" });
      }

      var previewTrigger = event.target instanceof Element ? event.target.closest("[data-open-cover-preview]") : null;
      if (previewTrigger && root.contains(previewTrigger)) {
        var uiState = getUiState(root);
        uiState.previewCover = {
          src: previewTrigger.getAttribute("data-cover-src") || "",
          title: previewTrigger.getAttribute("data-cover-title") || "Variant cover",
        };

        if (root.__darkstonePullListData && !root.__darkstonePullListData.requiresLogin) {
          var previewMessages = root.__darkstonePullListMessages || {};
          renderPortal(
            root,
            root.__darkstonePullListData,
            root.__darkstonePullListState || readQueryState(),
            previewMessages.notice || "",
            previewMessages.error || ""
          );
        }
        return;
      }

      var closePreview = event.target instanceof Element ? event.target.closest("[data-close-cover-preview]") : null;
      if (closePreview && root.contains(closePreview)) {
        var closeUiState = getUiState(root);
        closeUiState.previewCover = null;

        if (root.__darkstonePullListData && !root.__darkstonePullListData.requiresLogin) {
          var closeMessages = root.__darkstonePullListMessages || {};
          renderPortal(
            root,
            root.__darkstonePullListData,
            root.__darkstonePullListState || readQueryState(),
            closeMessages.notice || "",
            closeMessages.error || ""
          );
        }
        return;
      }

      var toggle = event.target instanceof Element ? event.target.closest("[data-toggle-pull-section]") : null;
      if (!toggle || !root.contains(toggle)) {
        return;
      }

      var sectionKey = toggle.getAttribute("data-toggle-pull-section");
      if (!sectionKey) {
        return;
      }

      var uiState = getUiState(root);
      uiState[sectionKey] = !Boolean(uiState[sectionKey]);

      if (root.__darkstonePullListData && !root.__darkstonePullListData.requiresLogin) {
        var messages = root.__darkstonePullListMessages || {};
        renderPortal(
          root,
          root.__darkstonePullListData,
          root.__darkstonePullListState || readQueryState(),
          messages.notice || "",
          messages.error || ""
        );
      }
    });

    document.addEventListener("keydown", function (event) {
      if (event.key !== "Escape") {
        return;
      }

      var uiState = getUiState(root);
      if (!uiState.previewCover) {
        return;
      }

      uiState.previewCover = null;

      if (root.__darkstonePullListData && !root.__darkstonePullListData.requiresLogin) {
        var messages = root.__darkstonePullListMessages || {};
        renderPortal(
          root,
          root.__darkstonePullListData,
          root.__darkstonePullListState || readQueryState(),
          messages.notice || "",
          messages.error || ""
        );
      }
    });
  }

  function mountRoot(root) {
    bindRoot(root);
    refresh(root);
  }

  function onReady(callback) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", callback, { once: true });
      return;
    }

    callback();
  }

  onReady(function () {
    var roots = document.querySelectorAll(ROOT_SELECTOR);
    roots.forEach(function (root) {
      mountRoot(root);
    });

    document.addEventListener("click", function (event) {
      var authStart = event.target instanceof Element ? event.target.closest("[data-pull-auth-start]") : null;
      if (!authStart || authStart.closest(ROOT_SELECTOR)) return;
      var root = document.querySelector(ROOT_SELECTOR);
      if (root) trackPullListEvent(root, "pull_auth_start", { placement: "landing-hero" });
    });
  });
})();
